import { render, staticRenderFns } from "./screenPopup.vue?vue&type=template&id=35e224eb"
import script from "./screenPopup.vue?vue&type=script&lang=js"
export * from "./screenPopup.vue?vue&type=script&lang=js"
import style0 from "./screenPopup.vue?vue&type=style&index=0&id=35e224eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports